export default __webpack_public_path__ + "static/media/postItRequested.1cc1c376.png";